<template>
  <section class="header">
    <SvgLogoCube class="header__logo"></SvgLogoCube>
    <div class="header__branding">
      <!-- <img class="header__branding__logo" src="" /> -->

      <div class="header__branding__text">
        <h1 class="alpha">Brandon Smith</h1>
        <p class="branding__text__tagline">
          Sr. Designer | Jr. Developer
        </p>
      </div>
      <div
        class="header__contact__toggle"
        ref="toggle"
        @click="toggleContact(), toggleToggle()"
      ></div>
      <div class="header__contact" ref="contact">
        <p class="header__contact__item">brandon@metawerks.net</p>
        <p class="header__contact__item">Dallas, TX 75208</p>
        <p class="header__contact__item">214.727.0680</p>
      </div>
    </div>

    <div class="header__settings">
      <div class="theme__wrapper" ref="settings">
        <ThemeButton></ThemeButton>
      </div>
      <div class="header__settings__toggle" @click="toggleSettings()">
        <p>Mode</p>
        <SvgIconGear></SvgIconGear>
      </div>
    </div>
  </section>
</template>
<script>
  import SvgIconGear from "@/components/svg/SvgIconGear.vue"
  import SvgLogoCube from "@/components/svg/SvgLogoCube.vue"
  // import SvgLogoCube2 from "@/components/svg/SvgLogoCube2.vue"

  import ThemeButton from "@/components/ThemeButton.vue"

  export default {
    name: "Header",
    data() {
      return {}
    },
    components: {
      SvgIconGear,
      SvgLogoCube,
      // SvgLogoCube2,
      ThemeButton,
    },
    methods: {
      toggleContact() {
        this.$refs.contact.classList.toggle("active")
      },
      toggleToggle() {
        this.$refs.toggle.classList.toggle("active")
      },
      toggleSettings() {
        this.$refs.settings.classList.toggle("active")
      },
    },
  }
</script>
<style lang="scss">
  @import "./src/scss/style--light";
  html {
    font-size: 14px;
  }
  @media screen and (min-width: 425px) {
    html {
      font-size: 16px;
    }
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    padding: 1rem 0;
    color: rgba(var(--text-tertiary), 1);
    @media screen and (min-width: 800px) {
      flex-direction: row;
      justify-content: flext start;
      align-items: center;
    }
  }

  .header__logo {
    max-width: 50px;
    width: auto;
  }

  .header__settings {
    position: absolute;
    top: 10px;
    right: 20px;

    display: flex;
    flex-direction: row;
    cursor: pointer;
    align-items: center;
    margin-left: 0;
    @media screen and (min-width: 800px) {
      margin-left: auto;
      position: relative;
    }
  }

  .header__settings svg {
    width: 1.5rem;
    margin-left: 0.25rem;
  }

  .header__settings p {
    color: rgba(var(--text-tertiary), 1);
    font-size: 0.8rem;
  }

  .header__settings__toggle {
    display: flex;
    position: relative;
    z-index: 2;
    // background: rgba(var(--background-primary), 1);
    padding-left: 1rem;
    margin-left: 1rem;
  }

  .header__branding {
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: 800px) {
      flex-direction: row;
    }
  }

  .header__branding:hover .branding__text__tagline {
    color: rgba(var(--text-primary), 1);
  }

  .header__branding__logo {
    width: 50px;
    height: 50px;
    margin-right: 1rem;
  }

  .header__branding__text {
    margin: 0;
    padding-right: 0;
    border-right: none;
    // background-color: rgba(var(--background-primary), 1);
    position: relative;
    z-index: 2;
    text-align: center;
    @media screen and (min-width: 800px) {
      margin: 0 1rem;
      padding-right: 1rem;
      border-right: 1px solid rgba(var(--text-tertiary), 1);
      text-align: left;
    }
  }

  .header__branding__text h1 {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 900;
    color: rgba(var(--text-secondary), 1);
    @media screen and (min-width: 641px) {
      font-size: 1.8rem;
    }
  }
  .header__branding__text p {
    margin: 0;
    font-weight: 400;
  }

  .header__contact__toggle {
    display: none;
    width: 16px;
    height: 16px;
    padding: 4px;
    content: url("/img/icon-arrow.svg");
    background-color: rgba(var(--background-secondary), 1);
    position: relative;
    right: 1.5rem;
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
    @media screen and (min-width: 800px) {
      display: block;
    }
  }

  .theme__wrapper {
    position: relative;
    // top: -40px;
    z-index: 1;
    opacity: 0;
    transition: top 0.2s cubic-bezier(0.33, 1, 0.68, 1),
      opacity 1s cubic-bezier(0.33, 1, 0.68, 1);
  }
  .theme__wrapper.active {
    // top: 0px;
    opacity: 1;
  }

  .header__contact__toggle.active {
    transform: rotate(180deg);
  }

  .branding__text__tagline {
    color: rgba(var(--text-tertiary), 1);
    transition: color 0.5s ease-out;
    font-size: 0.8rem;
    @media screen and (min-width: 641px) {
      font-size: 1.2rem;
    }
  }

  .header__contact {
    display: none;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    left: -200px;
    z-index: 1;
    opacity: 0;
    transition: left 0.2s cubic-bezier(0.33, 1, 0.68, 1),
      opacity 0.1s cubic-bezier(0.33, 1, 0.68, 1);
    @media screen and (min-width: 800px) {
      display: flex;
    }
  }

  .header__contact.active {
    left: -1rem;
    opacity: 1;
  }

  .header__contact:hover .header__contact__item {
    color: rgba(var(--text-primary), 1);
  }

  .header__contact__item {
    font-size: 0.8rem;
    color: rgba(var(--text-tertiary), 1);
    margin: 0 0 0rem 0;
    padding: 0;
    display: flex;
    align-items: center;
    transition: color 0.5s ease-out;
  }
</style>
